import React from 'react'
import {createIcon} from '@chakra-ui/react'

export const PencilIcon = createIcon({
  displayName: 'CogIcon',
  viewBox: '0 0 18 18',
  path: (
    <path
      d="M10.5441 6.765L11.2341 7.455L4.43908 14.25H3.74908V13.56L10.5441 6.765ZM13.2441 2.25C13.0566 2.25 12.8616 2.325 12.7191 2.4675L11.3466 3.84L14.1591 6.6525L15.5316 5.28C15.8241 4.9875 15.8241 4.515 15.5316 4.2225L13.7766 2.4675C13.6266 2.3175 13.4391 2.25 13.2441 2.25ZM10.5441 4.6425L2.24908 12.9375V15.75H5.06158L13.3566 7.455L10.5441 4.6425Z"
      fill="currentColor"
    />
  ),
})
